import React from 'react';
import { Button } from './Button';
export const CTASection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-700 to-teal-900 text-white py-16" data-id="element-92">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-93">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-94">
          Start Healing Now
        </h2>
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-95">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nUeLAzzv45miakpemeQKce/Mockups_-_21_Day_Program_2.png" alt="Neurotoned program materials including journal and guides" className="w-full rounded-lg shadow-xl mb-8" data-id="element-96" />
        </div>
        <div className="text-center mb-10 space-y-4" data-id="element-97">
          <p className="text-lg" data-id="element-98">You already know this work matters.</p>
          <p className="text-lg" data-id="element-99">
            Let Neurotoned help you finally <em data-id="element-100">live</em> it.
          </p>
          <p className="text-xl font-bold mt-6" data-id="element-101">
            One-time payment: normally $70 — today just $29
          </p>
          <p className="text-lg" data-id="element-102">
            Lifetime access. Therapist-led. Start today.
          </p>
          <p className="text-lg font-bold italic text-red-300 mt-4" data-id="element-103">
            This special $29 Founder's Rate is only available for a limited
            time. It will return to $70 once this cohort closes.
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-4" data-id="element-104">
          <Button link={checkoutUrl} data-id="element-105">Start My Reset – Just $29 ➔</Button>
          <Button link={checkoutUrl} className="bg-teal-700 hover:bg-teal-800" data-id="element-106">
            Begin My Nervous System Healing Today ➔
          </Button>
          <Button link={checkoutUrl} className="bg-teal-700 hover:bg-teal-800" data-id="element-107">
            Get Lifetime Access – Join Now for $29 ➔
          </Button>
        </div>
      </div>
    </section>;
};